import {Link, useLocation} from "react-router";
import {Plus, Swords} from "lucide-react";
import {parseAsString, useQueryState} from "nuqs";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import {useEncountersQuery} from "@/encounter/EncounterQueries.ts";
import EncounterCard from "@/encounter/EncounterCard.tsx";
import {Button} from "@/components/ui/button.tsx";
import SearchBar from "@/search/SearchBar.tsx";

export default function EncounterEmpty() {
    const {campaign, campaignPath} = useCampaign();
    const {search} = useLocation();
    const [name, setName] = useQueryState("name", parseAsString.withDefault(""));
    const query = useEncountersQuery(campaign.id, name.trim());

    return <main className="min-h-0 grow overflow-auto p-6 md:p-10">
        <title>Encounter verwalten | DireDawn</title>
        <div className="mx-auto max-w-5xl space-y-6">
            <div className="flex flex-wrap items-start justify-between gap-4">
                <div className="flex items-center gap-3">
                    <Swords className="size-8 text-destructive"/>
                    <h1 className="text-3xl font-semibold tracking-tight">Encounter</h1>
                </div>
                <Button asChild><Link to={campaignPath("encounters/new")}><Plus/>Neuer Encounter</Link></Button>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="w-full max-w-sm"><SearchBar value={name} onChange={setName} placeholder="Encounter suchen"/></div>
                {!query.isPending && !query.isError &&
                    <p className="text-sm text-muted-foreground">{query.totalCount} Encounter</p>}
            </div>
            {query.isPending && <p role="status" className="text-muted-foreground">Encounter werden geladen…</p>}
            {query.isError && <div role="alert">Encounter konnten nicht geladen werden. <Button variant="outline" size="sm" onClick={() => void query.refetch()}>Erneut laden</Button></div>}
            {!query.isPending && !query.isError && query.encounters.length === 0 &&
                <div className="rounded-xl border border-border bg-card/60 p-8 text-center text-muted-foreground">
                    {name.trim() ? "Keine Encounter entsprechen der Suche." : "Noch keine Encounter vorhanden. Lege deinen ersten Encounter an."}
                </div>}
            {query.encounters.length > 0 && <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {query.encounters.map(encounter => <EncounterCard key={encounter.id} encounter={encounter}
                    to={{pathname: campaignPath(`encounters/${encounter.id}`), search}}/>)}
            </div>}
            {query.hasNextPage && <div className="text-center">
                <Button variant="outline" disabled={query.isFetchingNextPage} onClick={() => void query.loadMore()}>
                    {query.isFetchingNextPage ? "Lade…" : "Weitere Encounter laden"}
                </Button>
            </div>}
        </div>
    </main>;
}
